import React from 'react'

import i18n from 'i18next'

import { Divider } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

import SearchAdvancedTipsRow from './Components/SearchAdvancedTipsRow/SearchAdvancedTipsRow'

function translate(keyFor, locale) {
  return i18n.t(`navigation.search.advancedTips.${keyFor}`, { ns: 'rails', lng: locale })
}

function SearchAdvancedTips({ showTitle = false, locale = 'en' }) {
  const title = translate('title', locale)
  const intro = translate('intro', locale)
  const syntax = translate('syntax', locale)
  const example = translate('example', locale)
  const description = translate('description', locale)
  const exactPhrase = translate('exactPhrase', locale)
  const hideResults = translate('hideResults', locale)
  const onlyShowResults = translate('onlyShowResults', locale)
  const showResultsEither = translate('showResultsEither', locale)
  const showResultsBoth = translate('showResultsBoth', locale)
  const showResultsStartsWith = translate('showResultsStartsWith', locale)
  const showResultsThreeLetters = translate('showResultsThreeLetters', locale)

  return (
    <div className="advanced-tips">
      {showTitle && <h3 className="advanced-tips__title">{title}</h3>}
      <div className="advanced-tips__content">
        {/* eslint-disable-next-line react/no-danger */}
        <p className="advanced-tips__intro" dangerouslySetInnerHTML={{ __html: intro }} />

        <Divider />

        <div className="advanced-tips__table">
          <div className="advanced-tips__header">
            <div className="advanced-tips__column advanced-tips__column--syntax">{syntax}</div>
            <div className="advanced-tips__column advanced-tips__column--example">{example}</div>
            <div className="advanced-tips__column advanced-tips__column--description">{description}</div>
          </div>

          <SearchAdvancedTipsRow code={`"phrase"`} example={`"robot arm"`} description={exactPhrase} />

          <SearchAdvancedTipsRow code="-word" example="-jewelry" description={hideResults} />

          <SearchAdvancedTipsRow code="+word" example="+furniture" description={onlyShowResults} />

          <SearchAdvancedTipsRow code="word1 OR word2" example="car OR truck" description={showResultsEither} />

          <SearchAdvancedTipsRow code="word1 AND word2" example="plane AND military" description={showResultsBoth} />

          <SearchAdvancedTipsRow code="*" example="robot*" description={showResultsStartsWith} />

          <SearchAdvancedTipsRow code="?" example="p?n" description={showResultsThreeLetters} />
        </div>
      </div>
    </div>
  )
}

SearchAdvancedTips.propTypes = {
  showTitle: bool,
  locale: string,
}

export default SearchAdvancedTips
